import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';

export interface CampaignData {
  id: number;
  campaign: string;
  campaign_name: string;
}

export interface CampaignOption {
  value: string;
  label: string;
}

const getCampaigns = async (): Promise<CampaignData[]> => {
  const response = await axios.get('intents/campaigns');
  return response.data;
};

export const useCampaigns = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['campaigns'],
    queryFn: getCampaigns,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  // Transform API response to dropdown options format
  const campaignOptions: CampaignOption[] = data
    ? data.map((campaign) => ({
        value: campaign.campaign,
        label: campaign.campaign,
      }))
    : [];

  // Remove duplicates since multiple campaigns can have the same name
  const uniqueCampaignOptions = campaignOptions.filter(
    (option, index, self) => index === self.findIndex((opt) => opt.value === option.value)
  );

  return {
    campaigns: data || [],
    campaignOptions: uniqueCampaignOptions,
    isLoading,
    error,
  };
};
